import { ReactElement } from 'react';
import { useOnFieldChange } from '@ff-it/form';
import { useForm } from 'react-final-form';
import { createOptions } from 'options';
import { SearchFilterInput } from 'components/filters/SearchFilterInput';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { DateRangeFilterChip } from 'components/filters/DateRangeFilterChip';

const periodFilter = ['ONGOING', 'ENDED', 'CUSTOM'] as const;

const periodOptions = createOptions(periodFilter, {
  ONGOING: 'Ongoing',
  ENDED: 'Ended',
  CUSTOM: 'Custom',
});

const statusOptions = createOptions(['enabled', 'disabled', 'all'] as const, {
  enabled: 'Enabled',
  disabled: 'Disabled',
  all: 'All',
});

export const guaranteeDefaultFilter = { status: 'enabled' };

export function GuaranteeFilter(): ReactElement {
  return <Filter guarantees />;
}

export function Filter({ guarantees = false }: { guarantees?: boolean }): ReactElement {
  const form = useForm();
  const period = useOnFieldChange(
    'period',
    (value) => {
      if (value !== 'CUSTOM' && form.getState().values.date_from) {
        form.batch(() => {
          form.change('date_from', null);
          form.change('date_to', null);
        });
      }
    },
    false,
  );

  return (
    <>
      <SearchFilterInput />
      {guarantees && <SelectFilterChip name="status" options={statusOptions} defaultValueLabel="Enabled" />}
      <SelectFilterChip name="period" options={periodOptions} defaultValueLabel="All" />
      {period === 'CUSTOM' && <DateRangeFilterChip label="Range" fromName="date_from" toName="date_to" />}
    </>
  );
}
